import { useQuery } from "@tanstack/react-query";
import { IReward } from "components/ScreenComponent/StartEarningRewardsComponent/StartEarningRewardsComponent";
import { useAppContext } from "contexts";

type SiteRewardsResponse = {
  items: IReward[];
  totalCount: number;
};

export function useGetSiteRewardsQuery({ skip = 0, take = 10 }: { skip?: number; take?: number }) {
  const { apiService } = useAppContext();

  return useQuery({
    queryKey: ["site-rewards", { skip, take }],
    queryFn: async (): Promise<SiteRewardsResponse> => {
      const params = new URLSearchParams();
      params.set("skip", String(skip));
      params.set("take", String(take));

      return apiService.get<SiteRewardsResponse>(`/site-rewards?${params.toString()}`);
    },
    retry: 3,
    retryDelay: 1000,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
}
